<template>
  <img v-if="photoData != null" :src="photoData">
</template>

<script>
import * as api from '@/lti/api'
import { defaultErrorMessage } from '@/helpers'

export default {
  name: 'PhotoComponent',
  props: {
    student: {
      required: true,
    },
  },
  data () {
    return {
      photoData: null,
    }
  },
  mounted () {
    if (this.student.attributes.hasPhoto) {
      let url = this.student.attributes.photo.split(/students/)

      api.getPhoto(url[1]).then((data) => { this.photoData = 'data:image/jpg;base64,' + new Buffer(data.data, 'binary').toString('base64') })
        .catch(error => defaultErrorMessage(error))
    } else {
      this.photoData = this.student.attributes.photo
    }
  },
}
</script>

<style scoped>

</style>
